import "react";
import { Number } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/components/FormikFields/FormikNumber.tsx
var FormikNumber = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => /* @__PURE__ */ jsx(Number, {
			...props,
			error: (meta.touched || !!form.submitCount) && meta.error,
			valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
			onChangeValue: (value) => props.name && form.setFieldValue(props.name, value),
			...field,
			onBlur: (e) => {
				if (props.onBlur) props.onBlur(e);
				field.onBlur(e);
			},
			onChange: null
		})
	});
};
//#endregion
export { FormikNumber };

//# sourceMappingURL=FormikNumber.js.map